import { colors } from '@ardoq/design-tokens';
import { HtmlCanvasVisual, IRenderContext, Rect } from '@ardoq/yfiles';
import { MODERNIZED_BLOCK_DIAGRAM_FONT as FONT } from '@ardoq/graph-labeling';

class DescendantCountLabelVisual extends HtmlCanvasVisual {
  constructor(
    private text: string,
    private bounds: Rect,
    private isTransparentized: boolean
  ) {
    super();
  }
  override render(
    _renderContext: IRenderContext,
    ctx: CanvasRenderingContext2D
  ): void {
    const { globalAlpha } = ctx;
    const { x, y, width, height } = this.bounds;

    if (this.isTransparentized) {
      ctx.globalAlpha = 0.32;
    }

    ctx.beginPath();
    ctx.roundRect(x, y, width, height, height / 2);
    ctx.fillStyle = colors.grey900;
    ctx.fill();

    ctx.fillStyle = colors.white950;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = FONT;
    ctx.fillText(this.text, x + width / 2, y + height / 2);

    ctx.globalAlpha = globalAlpha;
  }
}
export { DescendantCountLabelVisual };
